import hptr from '@/views/homepage-tr'
import hakkimizda from '@/views/hakkimizda'
import faaliyet from '@/views/faaliyet'
import ekip from '@/views/ekip'
import yayinlar from '@/views/yayinlar'
import iletisim from '@/views/iletisim'
import gizlilik from '@/views/gizlilik'
import cerezPolitikasi from '@/views/cerez-politikasi'
import yasalBildirimler from '@/views/yasal-bildirimler'
import bulten from '@/views/bulten'


export const tr = [
  {
    path: '',
    name: 'homepage-tr',
    component: hptr,
    meta: {
      policy: true,
      tur: true
    }
  },
  {
    path: 'hakkimizda',
    name: 'hakkimizda',
    component: hakkimizda,
    meta: {
      tur: true
    }
  },
  {
    path: 'hukuk-faaliyet-alanlari',
    name: 'faaliyet',
    component: faaliyet,
    meta: {
      tur: true
    },
  },
  {
    path: 'ekibimiz',
    name: 'ekip',
    component: ekip,
    meta: {
      tur: true
    },
  },,
  {
    path: 'bulten',
    name: 'bulten',
    component: bulten,
    meta: {
      tur: true
    },
  },
  {
    path: 'yayinlar',
    name: 'yayinlar',
    component: yayinlar,
    meta: {
      tur: true
    }
  },
  {
    path: 'iletisim',
    name: 'iletisim',
    component: iletisim,
    meta: {
      tur: true
    }
  },
  {
    path: 'gizlilik-politikasi',
    name: 'gizlilik',
    component: gizlilik,
    meta: {
      tur: true
    }
  },
  {
    path: 'cerez-politikasi',
    name: 'cerez-politikasi',
    component: cerezPolitikasi,
    meta: {
      tur: true
    }
  },
  {
    path: 'yasal-bildirimler',
    name: 'yasal-bildirimler',
    component: yasalBildirimler,
    meta: {
      tur: true
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/tr.js